import type { CSSProperties, ReactNode } from "react";

interface SideBySideProps {
  eyebrow?: string;
  title: string;
  body: ReactNode;
  media?: string;
  imageSrc?: string;
  imageAlt?: string;
  imageWidth?: string | number;
  imageHeight?: string | number;
  reverse?: boolean;
}

export const SideBySide: React.FC<SideBySideProps> = ({
  eyebrow,
  title,
  body,
  media,
  imageSrc,
  imageAlt,
  imageWidth,
  imageHeight,
  reverse,
}) => {
  // Custom styles for image container when dimensions are provided
  const mediaStyles: CSSProperties = {};
  if (imageWidth) {
    mediaStyles.width =
      typeof imageWidth === "number" ? `${imageWidth}px` : imageWidth;
    mediaStyles.aspectRatio = "unset";
  }
  if (imageHeight) {
    mediaStyles.height =
      typeof imageHeight === "number" ? `${imageHeight}px` : imageHeight;
    mediaStyles.aspectRatio = "unset";
  }

  return (
    <div className={"sxs" + (reverse ? " sxs--reverse" : "")}>
      <div className="sxs__media" style={mediaStyles}>
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={imageAlt || media || title}
            crossOrigin="anonymous"
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="placeholder">
            <span>{media || "screenshot or diagram"}</span>
          </div>
        )}
      </div>
      <div className="sxs__copy">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h3>{title}</h3>
        <p>{body}</p>
      </div>
    </div>
  );
};
